var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('iframe',{ref:"metabase",attrs:{"src":_vm.src,"width":"100%","height":"100%","frameborder":"0","allowtransparency":""}}):(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('i',{staticClass:"el-icon-loading"})]):(_vm.error)?_c('div',{staticClass:"error-container"},[_vm._v("\n  "+_vm._s(_vm.error)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02a3e336","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/metabase/pages/MetabaseApplication.vue
// module id = null
// module chunks = 